import { LocalNotificationsPlugin } from '@capacitor/local-notifications';

import { AlarmWithUserAlarm } from 'src/models/alarm';

import { Callback } from 'src/util/query/models/Callback';

import { AlarmTranslator } from '../types';
import { AlarmAcquisitionCompletion } from './AlarmAcquisitionCompletion';
import {
	AlarmAcquisitionResult,
	BACKGROUND_ALARM_ACQUISITION,
	createFailedAlarmAcquisition,
	createSuccessfulAlarmAcquisition,
	reconcileAlarmNotifications,
} from './AlarmNotificationReconciler';

export class BackgroundAlarmCallback extends Callback<Array<AlarmWithUserAlarm>> {
	private readonly acquisitionCompletion = new AlarmAcquisitionCompletion();

	public constructor(
		private readonly localNotifications: LocalNotificationsPlugin,
		private readonly setAlarms: (alarms: AlarmWithUserAlarm[]) => void,
		private readonly t: AlarmTranslator
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): AlarmAcquisitionResult => {
		this.acquisitionCompletion.markStarted();
		this.logFailureResponse(failureResponse);
		const result = createFailedAlarmAcquisition(BACKGROUND_ALARM_ACQUISITION);
		this.acquisitionCompletion.resolve(result);
		return result;
	};

	successCallbackFunction = (successResponse: Array<AlarmWithUserAlarm>): void => {
		this.acquisitionCompletion.markStarted();
		const snapshot = createSuccessfulAlarmAcquisition(successResponse, BACKGROUND_ALARM_ACQUISITION);
		if (!this.localNotifications) {
			this.acquisitionCompletion.resolve(createFailedAlarmAcquisition(BACKGROUND_ALARM_ACQUISITION));
			return;
		}

		this.setAlarms(snapshot.desiredRows);

		void reconcileAlarmNotifications(snapshot, this.localNotifications, this.t).then(
			() => this.acquisitionCompletion.resolve(snapshot),
			(error: unknown) => this.acquisitionCompletion.reject(error)
		);
	};

	public hasAcquisitionStarted(): boolean {
		return this.acquisitionCompletion.hasStarted();
	}

	public waitForAcquisitionCompletion(): Promise<AlarmAcquisitionResult> {
		return this.acquisitionCompletion.wait();
	}
}
